<template>
  <div class="sp-template">
    <div class="h-title">订单费用异常</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="类型">
              <el-select v-model="queryForm.type" @change="searchTask()">
                <el-option v-if="in_configs(41207)" key="1" label="扣费异常" value="1"></el-option>
                <el-option v-if="in_configs(41208)" key="2" label="计费异常" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
              <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="仓库">
              <el-select v-model.lazy="queryForm.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input type="textarea" v-model="orderIds" placeholder="多个订单号用回车分割"></el-input>
            </el-form-item>
          </el-row>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(41203)" type="primary" size="small" @click="searchTask()">搜 索</el-button>
            <el-button v-if="in_configs(41203)" size="small" @click="reset()">清 空</el-button>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="queryForm.status" @tab-click="searchTask">
          <el-tab-pane v-if="in_configs(41201)" label="未处理" name="0"></el-tab-pane>
          <el-tab-pane v-if="in_configs(41202)" label="已处理" name="1"></el-tab-pane>
        </el-tabs>
        <div class="button-groups" v-if="queryForm.status==0 && queryForm.type==1">
          <el-button v-if="in_configs(41204)" size="small" @click="deliverGoodsPop()">允许发货</el-button>
          <el-button v-if="in_configs(41209)" size="small" @click="batchProcessException()">异常处理</el-button>
        </div>
      </div>
      <el-table :data="tableData" stripe border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column label="仓库">
            <template slot-scope="scope">
                {{warehouseMap[scope.row.warehouseCode]}}
            </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.productId]}}
          </template>
        </el-table-column>
        <el-table-column prop="chargeType" label="费用名称"></el-table-column>
        <el-table-column prop="exceptionMessage" label="异常信息"></el-table-column>
        <el-table-column label="日期">
          <template slot-scope="scope">
            {{dateFormat(new Date(scope.row.createTime), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="queryForm.status==0">
          <template slot-scope="scope">
            <el-button v-show="in_configs(41205) && scope.row.type=='exception'" type="text" size="mini" @click="popProcessed(scope.row)">计费异常处理</el-button>
            <el-button v-show="in_configs(41206) && scope.row.type=='transaction'" type="text" size="mini" @click="popProcessed(scope.row)">扣费异常处理</el-button>
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="dialogFormVisible = true">提货</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryForm.currentPage" :page-sizes="[10, 50, 100, 200, 300, 400]" :page-size="queryForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

    </el-card>

    <!-- 提示弹框 -->
    <el-dialog title="提示" :visible.sync="dialogCheckVisible" width="450px">
      <el-form size="small">
        该异常是否已处理？
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="processed()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 提示弹框2 -->
    <el-dialog title="提示" :visible.sync="dialogCheckVisible2" width="450px">
      <el-form size="small">
        是否允许发货？
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible2 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="deliverGoods()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogCheckVisible3" width="450px">
      <el-form size="small">
        选择的异常是否已处理？
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible3 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="batchProcessed()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      tableDataMap: {},
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},
      orderIds: "",
      queryForm: {
        warehouseIds: [],
        orderIds: [],
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0,
        currentPage: 1,
        pageSize: 10,
        status: "0",
        type: "2"
      },

      warehouses:[],
        warehouseMap: {},

      total: 0,
      chargeType: [],
      chargeTypeMap: {},
      dialogCheckVisible: false,
      theId: "",
      orderId: "",
      chargeType: "",
      type: "",
      multipleSelection: [], //表单选中的数据
      dialogCheckVisible2: false,
      dialogCheckVisible3: false
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      let _this = this;
      let urlArray = [this.findAllCustomerName(), this.findAllChannle(), this.findAllWarehouse()];
      this.$axios.all(urlArray).then(
        this.$axios.spread(function(customerData, channelData, warehouseData) {
          _this.initCustomerData(customerData);
          _this.initChannelData(channelData);
          _this.initWarehouseData(warehouseData);
          _this.getChargeType();
          _this.query();
        })
      );
    }, 1000);
  },
  methods: {
    // 在左侧菜单显示异常费用的总条数，由于菜单被集成到第三方插件中，当前的方法比较死板，一旦订单操作的二级菜单发生改变，这个方法获取的dom元素也要变
    createElement(num) {
      if (num > 0) {
        let spMenu = document.getElementsByClassName("sp-menu")[0];
        let items = spMenu.childNodes[4].getElementsByTagName("ul")[0];
        let target = items.getElementsByClassName("sp-menu-item")[14];
        let newChild = document.createElement("span");
        newChild.innerHTML = num;
        newChild.setAttribute("class", "abnormalChargeNums");
        newChild.style.position = "absolute";
        newChild.style.top = "15px";
        newChild.style.right = "15px";
        newChild.style.padding = "2px 5px";
        newChild.style.width = "35px";
        newChild.style.borderRadius = "12px";
        newChild.style.textAlign = "center";
        newChild.style.backgroundColor = "#ED6B75";
        newChild.style.color = "#fff";
        target.appendChild(newChild);
      } else {
        return;
      }
    },
    //分页
    handleSizeChange(val) {
      this.queryForm.currentPage = 1;
      this.queryForm.pageSize = val;
      this.query();
    },
    handleCurrentChange(val) {
      this.queryForm.currentPage = val;
      this.query();
    },
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all',
          {
            withCredentials: true
          }
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll',
          {
            withCredentials: true
          }
      );
    },
    //获取仓库
    findAllWarehouse() {
      return this.$request1.get(
        '/warehouse/staff',
          {
            withCredentials: true
          }
      );
    },
    initWarehouseData(data) {
      let _this = this;
      _this.warehouses = data.data;
        _this.warehouses.forEach(a => {
            _this.warehouseMap[a.id] = a.name;
        });
    },
    initChannelData(data) {
      let _this = this;
      _this.channels = data.data;
      if (_this.channels.length > 0) {
        _this.channels.forEach(c => {
          _this.channelsMaps[c.id] = c.name;
        });
      }
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    reset() {
      this.orderIds = ""
      this.queryForm = {
        warehouseIds: [],
        orderIds: [],
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0,
        currentPage: 1,
        pageSize: 10,
        status: "0",
        type: "1"
      }
      this.searchTask()
    },
    searchTask() {
      //this.currentPage = 1;
      this.queryForm.currentPage = 1;
      this.query();
    },
    query() {
      let _this = this;
      this.queryForm.orderIds = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }

      //过滤仓库
        let wlist = [];
        if(this.warehouses!=null && this.warehouses.length>0){
            if(_this.queryForm.warehouseIds && _this.queryForm.warehouseIds.length>0){
                wlist = _this.queryForm.warehouseIds;
            }else{
                wlist = this.warehouses.map(a => a.id);
            }
        }else{
            wlist.push("NOT MATCHING");
        }
        let newForm = {};
        newForm = JSON.parse(JSON.stringify(_this.queryForm));
        newForm.warehouseIds = wlist;

      this.$request1({
        url: '/order/charge/exception/query',
        method: "post",
        withCredentials: true,
        data: newForm
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            _this.tableData = data.data.list;
            _this.total = data.total;

            var exceptionTotal = data.data.exceptionTotal;
            if (exceptionTotal > 0) {
              _this.createElement(_this.exceptionTotal);

              //map:
              _this.tableDataMap = {};
              _this.tableData.forEach(a => {
                _this.tableDataMap[a.id] = a;
              });
            }
          } else {
            _this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            _this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    //获取费用类型
    getChargeType() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/order/charge-type',
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          this.chargeType = data;
          data.forEach((d, i) => {
            this.chargeTypeMap[d.code] = d.name;
          });
        })
        .catch(error => {
          _this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    dateFormat(date, fmt) {
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2
              ? "/u661f/u671f"
              : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },
    popProcessed(data) {
      this.dialogCheckVisible = true;
      this.theId = data.id;
      this.orderId = data.orderId;
      this.chargeType = data.chargeType;
      this.type = data.type;
    },
    processed() {
      let _this = this;
      if (this.theId != null && this.theId.trim() != "") {
        _this.$request1
          .post(
            '/order/charge/exception/process',
            {
              id: _this.theId,
              orderId: _this.orderId,
              chargeType: _this.chargeType,
              type: _this.type
            },
            {
              withCredentials: true
            }
          )
          .then(function(res) {
            if (res.data.success) {
              _this.$message.success("Success");
              for (let i = 0; i < _this.tableData.length; i++) {
                let d = _this.tableData[i];
                if (d.id == _this.theId) {
                  _this.tableData.splice(i, 1);
                  break;
                }
              }
            } else {
              _this.$alert(res.data.message, "提示");
            }
            _this.query();
          })
          .catch(function(error) {
            console.log(error);
            _this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          });
      }
      this.dialogCheckVisible = false;
    },
    //多选按钮
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deliverGoods() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择订单");
        return false;
      }
      let ids = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        ids.push(this.multipleSelection[i].id);
      }

      _this.$request1({
        url: '/order/charge/exception/allow-deliver',
        method: 'post',
        data: {
          ids: ids
        }
      })
        .then(function(res) {
          if (res.data.success) {
            _this.$message.success("Success");
            _this.query();
            _this.dialogCheckVisible2 = false;
          } else {
            let message = ""
            if(res.data.data) { // 保持原来的写法，龙艺芳说正常不会走这里，由于不知道这个功能是谁做的，具体应该返回哪几种错误，暂时也不知道
              message = res.data.data;
              var tip = ""
              var mjson = JSON.parse(message.exceptionResponseList);
              mjson.forEach(a => {
                var orderId = _this.tableDataMap[a.subsystemTxId].orderId;
                var chargeType = _this.tableDataMap[a.subsystemTxId].chargeType;
                tip +=
                  "订单" +
                  orderId +
                  " " +
                  chargeType +
                  " 扣费失败，\r\n 原因：" +
                  a.message +
                  " \r\n ";
              });
              _this.$message.error(tip);
            } else { // 针对不允许重复交易的情况，后台实际返回的内容是 {"success":false,"message":"不允许重复交易"}
              message = res.data.message
              _this.$message.error(message);
            }
            _this.query(); // 这个查询有待商榷，提示不允许重复交易后，再点允许发货就成功了，龙艺芳说是因为这里刷新了导致的，说暂时不管^^
            _this.dialogCheckVisible2 = false;
          }
        })
        .catch(function(error) {
          _this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    deliverGoodsPop() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择订单");
        return false;
      }
      this.dialogCheckVisible2 = true;
    },
    batchProcessException() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择订单");
        return false;
      }
      this.dialogCheckVisible3 = true;
    },
    batchProcessed() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择订单");
        return false;
      }
      let ids = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        ids.push(this.multipleSelection[i].id);
      }

      _this.$request1
        .post(
          '/order/charge/exception/batch-process',
          {
            ids: ids
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.$message.success("Success");
            _this.query();
            _this.dialogCheckVisible3 = false;
          } else {
            if (!res.data.success && res.data.message != null) {
              _this.$alert(res.data.message);
              _this.query();
              _this.dialogCheckVisible3 = false;
              return;
            }
            let message = res.data.data;
            var tip = "";
            if (message.nonPaymentOrderIds) {
              tip =
                "订单" + message.nonPaymentOrderIds + "未付款，发货失败 \r\n ";
            }

            if (message.exceptionResponseList) {
              var mjson = JSON.parse(message.exceptionResponseList);
              mjson.forEach(a => {
                var orderId = _this.tableDataMap[a.subsystemTxId].orderId;
                var chargeType = _this.tableDataMap[a.subsystemTxId].chargeType;
                tip +=
                  "订单" +
                  orderId +
                  " " +
                  chargeType +
                  " 扣费失败，\r\n 原因：" +
                  a.message +
                  " \r\n ";
              });
            }
            if (message.error) {
              tip = message.error;
            }
            _this.query();
            _this.dialogCheckVisible3 = false;
            _this.$alert(tip);
          }
        })
        .catch(function(error) {
          _this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    }
  }
};
</script>

<style>
.el-message-box__message p {
  margin: 0;
  line-height: 24px;
  white-space: pre-wrap !important;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/abnormalcharge.vue